(function () {
  document.querySelectorAll('[data-product-list]').forEach(function (root) {
    var track = root.querySelector('[data-product-list-track]');
    var nextBtn = root.querySelector('[data-product-list-next]');
    var prevBtn = root.querySelector('[data-product-list-prev]');
    if (!track || (!nextBtn && !prevBtn)) return;

    function scrollAmount() {
      var first = track.querySelector('.aceites-product-list__item');
      if (!first) return 320;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '12') || 12;
      return first.getBoundingClientRect().width + gap;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        if (atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        }
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var atStart = track.scrollLeft <= 4;
        if (atStart) {
          track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        }
      });
    }
  });
})();
